module.exports = __webpack_public_path__ + "static/HBR_mockup-1_min-21e34d8598f522a36399c7f85b6faa54.jpg";